import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import AOS from "aos";
import "aos/dist/aos.css";

import "./App.css";

// Import components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Import pages
import Home from "./pages/Home";
import WhyUs from "./pages/WhyUs";
import MutualFunds from "./pages/MutualFunds";
import EquityCommodityTrading from "./pages/EquityCommodityTrading";
import DepositoryServices from "./pages/DepositoryServices";
import GlobalInvestments from "./pages/GlobalInvestments";
import FixedIncomeProducts from "./pages/FixedIncomeProducts";
import InsuranceProducts from "./pages/InsuranceProducts";
import OpenAnAccount from "./pages/OpenAnAccount";
import PartnerWithUs from "./pages/PartnerWithUs";
import OnlineTrading from "./pages/OnlineTrading";
import ContactUs from "./pages/ContactUs";
import Downloads from "./pages/Downloads";
import Policies from "./pages/Policies";
import VoluntaryFreezingPolicy from "./pages/VoluntaryFreezingPolicy";
import AdvisoryForInvestors from "./pages/AdvisoryForInvestors";
import AttentionInvestors from "./pages/AttentionInvestors";
import RiskDisclosuresOfDerivatives from "./pages/RiskDisclosuresOfDerivatives";
import Notice from "./pages/Notice";
import KnowYourKyc from "./pages/KnowYourKyc";
import ClientRegistrationDocuments from "./pages/ClientRegistrationDocuments";
import InvestorRelations from "./pages/InvestorRelations";
import ClientBankAccount from "./pages/ClientBankAccount";
import TermsAndConditions from "./pages/TermsAndConditions";
import GrievanceRedressalMechanism from "./pages/GrievanceRedressalMechanism";
import Kra from "./pages/Kra";
import NotFound from "./pages/NotFound";
import BranchOfficeDetails from "./pages/BranchOfficeDetails";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Refreshes AOS calculations whenever the route changes,
const AOSRefresher = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    AOS.refresh();
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    // Initialize AOS once when the app mounts
    AOS.init({
      duration: 800,
      once: false,
      offset: 100,
    });

    // Initialize jQuery-based functionality globally
    if (window.jQuery) {
      const $ = window.jQuery;

      // Menu dropdown functionality
      $(".dropdownMu .menu > ul > li").hover(
        function () {
          $(".backdrop").show();
        },
        function () {
          $(".backdrop").hide();
        },
      );

      $(".dropdownMu .single-item").hover(
        function () {
          $(".backdrop").hide();
        },
        function () {
          $(".backdrop").show();
        },
      );
    }
  }, []);

  return (
    <HelmetProvider>
      <Toaster position="top-right" reverseOrder={false} />
      <Router>
        <ScrollToTop />
        <AOSRefresher />
        <div className="App">
          <Header />

          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/why-us" element={<WhyUs />} />
              <Route path="/mutual-funds" element={<MutualFunds />} />
              <Route
                path="/equity-commodity-trading"
                element={<EquityCommodityTrading />}
              />
              <Route
                path="/depository-services"
                element={<DepositoryServices />}
              />
              <Route
                path="/global-investments"
                element={<GlobalInvestments />}
              />
              <Route
                path="/fixed-income-products"
                element={<FixedIncomeProducts />}
              />
              <Route
                path="/insurance-products"
                element={<InsuranceProducts />}
              />
              <Route path="/open-an-account" element={<OpenAnAccount />} />
              <Route path="/partner-with-us" element={<PartnerWithUs />} />

              <Route path="/online-trading" element={<OnlineTrading />} />
              <Route path="/contact-us" element={<ContactUs />} />

              {/* Others Section Routes */}
              <Route path="/branch-office-details" element={<BranchOfficeDetails />} />
              <Route path="/downloads" element={<Downloads />} />
              <Route path="/policies" element={<Policies />} />
              <Route
                path="/voluntary-freezing-policy"
                element={<VoluntaryFreezingPolicy />}
              />
              <Route
                path="/advisory-for-investors"
                element={<AdvisoryForInvestors />}
              />
              <Route
                path="/attention-investors"
                element={<AttentionInvestors />}
              />
              <Route
                path="/risk-disclosures-of-derivatives"
                element={<RiskDisclosuresOfDerivatives />}
              />
              <Route path="/notice" element={<Notice />} />
              <Route path="/know-your-kyc" element={<KnowYourKyc />} />
              <Route
                path="/client-registration-documents"
                element={<ClientRegistrationDocuments />}
              />
              <Route
                path="/investor-relations"
                element={<InvestorRelations />}
              />
              <Route
                path="/client-bank-account"
                element={<ClientBankAccount />}
              />
              <Route
                path="/terms-and-conditions"
                element={<TermsAndConditions />}
              />
              <Route
                path="/grievance-redressal-mechanism"
                element={<GrievanceRedressalMechanism />}
              />
              <Route path="/kra" element={<Kra />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
